exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stepHeader--11pzr {\n  font-size: 1.4em;\n}\n\n.dividingImg--2M3Vg {\n  display: block;\n  max-height: 150px;\n  margin: auto;\n}\n\n", ""]);

// exports
exports.locals = {
	"stepHeader": "stepHeader--11pzr",
	"dividingImg": "dividingImg--2M3Vg"
};